// extracted by mini-css-extract-plugin
export default {"row":"EmailChangeForm_row__gFyWW","error":"EmailChangeForm_error__84ksX","form":"EmailChangeForm_form__EpkMS","button":"EmailChangeForm_button__IIUDO"};